import { FunctionComponent } from 'react'

import Avatar from 'design-system/avatar'
import {
  AvatarSizes,
  AvatarVariant,
} from 'design-system/avatar/src/resources/Avatar.enum'
import { useIsMobile } from 'hooks/useIsMobile'
import styles from './UserBox.module.scss'

interface UserBox {
  name: string
  srcAvatar?: string
  id?: string
}

const UserBox: FunctionComponent<UserBox> = ({
  name,
  srcAvatar = '//placeimg.com/64/64/people',
  id = 'userBox',
}) => {
  const isMobile = useIsMobile()

  return (
    <div
      id={id}
      className={`${styles.userBox} ${isMobile ? styles.userBoxMobile : ''}`}
    >
      <div
        className={`${styles.userBoxDisplay} ${
          isMobile ? styles.userBoxMobile : ''
        }`}
      >
        <span className={styles.userName}>{name}</span>
        <Avatar
          src={srcAvatar}
          variant={AvatarVariant.Square}
          sizes={AvatarSizes.XExtraLarge}
          backgroundColor="#ffffff"
          className={styles.avatarBox}
          useOriginalImage
        />
      </div>
    </div>
  )
}

export default UserBox
